'use client';
const toUnstyledButtonNotAllowed = (notAllowed, disabled, loading)=>{
    if (!notAllowed) {
        return false;
    }
    switch(notAllowed){
        case true:
            return true;
        case 'disabled':
            {
                return disabled;
            }
        case 'loading':
            {
                return loading;
            }
    }
};

export { toUnstyledButtonNotAllowed };
//# sourceMappingURL=toUnstyledButtonNotAllowed.js.map
